<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit Charity</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/charities" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="updateCharity" v-if="charity">
                <div class="row justify-content-md-center">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-md-4">
                        <fg-input type="text"
                                  v-model="charity.givingName"
                                  label="Charity Name"
                                  placeholder="Enter Charity Name"
                                  v-validate="rules.givingName"
                                  data-vv-name="Name"
                                  cus-name="Name"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-4">
                        <fg-input type="text"
                                  v-model="charity.website"
                                  label="Website"
                                  placeholder="Enter Website"
                                  v-validate="rules.website"
                                  data-vv-name="Website"
                                  cus-name="Website"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-4">
                        <fg-input type="text"
                                  v-model="charity.imageUrl"
                                  label="Image URL"
                                  placeholder="Enter Image URL"
                                  v-validate="rules.website"
                                  data-vv-name="Image"
                                  cus-name="Image"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-12">
                        <fg-text-area type="text"
                                      v-model="charity.description"
                                      label="Description"
                                      placeholder="Enter Description"
                                   >
                        </fg-text-area>
                      </div>
                      <div class="col-3" v-if="status.length">
                        <fg-select
                          v-model="charity.active"
                          label="Status"
                          v-validate="rules.active"
                          data-vv-name="active"
                          cus-name="active"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="status"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                    </div>
                  </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Update Charity
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    import moment from 'moment'
    export default {
        name: 'EditCharity',
        created (){
        this.$store.dispatch('GETSELECTEDCHARITY', this.$route.params.id).then(() =>{
            this.charity = this.selectedCharity;
        })
    },
    data () {
        let dateTime = new Date();
        return {
            charity: this.selectedCharity || {},
          rules: {
            givingName: {required : true},
            imageUrl: {required: true},
            website: {required: true},
            active: {required: true}
          },
          message: {
            error: false,
            text: ''
          },
          status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
        }
    },
    methods: {
        updateCharity () {
          this.$validator.validateAll().then((result) => {
            if(result){

              let updateCharity = () =>{
                this.$store.dispatch('UPDATE_CHARITY', this.charity)
                  .then((res) => {
                    console.log("UPDATE_EVENT res : ", res);
                    this.showPopup('Success!', 'Charity is successfully updated', 'success', ()=>this.$router.push('/admin/charities'))

                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("UPDATE_CHARITY API error : ", err);
                  })
              };
              updateCharity();
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {...mapGetters([
        'charities', 'selectedCharity']) }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Charities/EditCharity.vue